/* ==========================================================================
   VJ-CORR-D385 — 16 septembre 2026 (vingtième tour) — LES CÉSURES SE POSENT
   PAR LA MESURE, À CHAQUE PASSAGE D'UN BLOC À UN AUTRE SUR LE MÊME SOL
   --------------------------------------------------------------------------
   Rachid : « dans tout le site, dès qu'on passe d'un bloc à l'autre, il faut
   qu'il y ait un trait qui sépare — avec une équidistance entre le trait et le
   texte avant, le trait et le texte après, à chaque fois. » « Il faut que le
   trait aille d'un bout à l'autre de l'iPhone : une séparation totale, comme
   quand on passe d'une couleur de bloc à une autre. »

   POURQUOI UN SCRIPT ET PAS TROIS RÈGLES. Relevé par traits.js (contrôle neuf)
   à 402 px : les trois césures fixes (pied du socle D358, haut de `.vj-avis`,
   bordure `.shape.border-top` du thème) s'éteignaient à 13-16 px des bords et
   tombaient à 42/33, 16/53, 34/25 px d'air — chaque page a son rembourrage, et
   l'en-tête qui se condense décale tout. §2.1 ter l'écrivait déjà : « SA
   POSITION EST UNE MESURE, PAS UNE VALEUR » ; la coupe de la page Live se mesure
   en script depuis D359. On généralise.

   CE QUE FAIT CE SCRIPT, sur chaque page :
   · il prend les sections visibles dans l'ordre (hors bandeau et en-tête) et,
     dans chacune, les bornes du CONTENU — texte en propre, image, champ,
     bouton, carte peinte ; jamais un calque de fond, ni ce qui est fixe ;
   · deux sections dont les contenus se chevauchent font un seul bloc ;
   · entre deux blocs, il lit le SOL au bas du premier et au haut du second (le
     fond peint le plus profond sous le point, x = 4) : s'il CHANGE, c'est la
     couleur qui sépare et il ne pose rien ; s'il est le MÊME, il pose une césure
     d'un pixel, sur TOUTE la largeur de la fenêtre, au milieu exact de l'air ;
   · crème → la recette brune (`vj-cesure-auto--creme`) ; brun → la recette or ;
   · la césure vit DANS la section qui contient ce milieu, en position absolue :
     l'en-tête qui se condense la déplace avec le contenu.
   Il se refait au chargement, aux polices, au redimensionnement, quand le corps
   change de hauteur (ResizeObserver : « Faites glisser » arrive après coup) et
   quand la grille du catalogue est remplacée (`vj:grille-remplacee`, §3.3).

   Rollback : retirer ce fichier et sa balise de layout/theme.liquid, et le bloc
   VJ-CORR-D385 de vj-premium.css (les trois césures fixes reviennent).
   ========================================================================== */
(function () {
  'use strict';
  var CLASSE = 'vj-cesure-auto';
  var MEME_SOL = 12;

  /* `.vj-reveal` (vj-motion.js) attend son entrée à l'écran à opacité 0, décalé
     de 28 px : c'est du contenu, et sa position de repos est sans décalage. */
  var visible = function (e) {
    var s = getComputedStyle(e);
    return s.display !== 'none' && s.visibility !== 'hidden' && (+s.opacity > .05 || !!e.closest('.vj-reveal, .aos-init'));
  };
  var fixe = function (e) {
    for (var a = e; a && a !== document.body; a = a.parentElement) {
      var p = getComputedStyle(a).position;
      if (p === 'fixed' || p === 'sticky') return true;
    }
    return false;
  };
  var MEDIA = /^(IMG|INPUT|TEXTAREA|SELECT|BUTTON|VIDEO|SVG)$/i;

  /* LA POSITION DE REPOS. Les blocs hors écran attendent leur apparition
     décalés vers le bas (`.vj-reveal`, translateY(28px), opacité 0) :
     mesurés au chargement, ils tombaient 30 à 80 px trop bas et la césure
     sortait de l'air (relevé : fiche produit, accueil, socle de Contact). On
     retire le décalage vertical de l'élément et de ses ancêtres. */
  var cache = null;
  var decalage = function (e) {
    if (!e || e === document.documentElement) return 0;
    if (cache.has(e)) return cache.get(e);
    var s = getComputedStyle(e), dy = 0;
    /* seul le décalage d'APPARITION est retiré : un `transform` permanent (une
       carte soulevée) est ce qu'on voit. Premier jet sans ce tri : les traits du
       socle remontaient de 19 px au-dessus du milieu. */
    /* relevé sur le socle de Contact : la carte ET son bloc attendaient, chacun
       à opacité 0 et décalé de 28 px, et un seul portait `.vj-reveal` */
    /* deux systèmes d'apparition : `.vj-reveal` → `.is-in` (vj-motion.js) et AOS du
       thème, `.aos-init` → `.aos-animate` (relevé : le titre des suggestions de la
       fiche, opacité 0 et 28 px plus bas au chargement) */
    var attend = (e.classList && e.classList.contains('vj-reveal') && !e.classList.contains('is-in')) ||
                 (e.classList && e.classList.contains('aos-init') && !e.classList.contains('aos-animate')) ||
                 (+s.opacity < .05 && !!e.closest('.vj-reveal, .aos-init'));
    if (attend && s.transform && s.transform !== 'none') {
      try { dy += new DOMMatrixReadOnly(s.transform).m42; } catch (x) {}
    }
    dy += decalage(e.parentElement);
    cache.set(e, dy);
    return dy;
  };

  var bornes = function (section) {
    var haut = Infinity, bas = -Infinity;
    var W = document.documentElement.clientWidth;
    var tous = section.querySelectorAll('*');
    for (var i = 0; i < tous.length; i++) {
      var e = tous[i];
      if (e.classList && e.classList.contains(CLASSE)) continue;
      if (e.closest('.offcanvas, .modal, .visually-hidden, #shopify-pc__banner')) continue;
      var r = e.getBoundingClientRect();
      if (r.width < 2 || r.height < 2) continue;
      var texte = false;
      for (var n = e.firstChild; n; n = n.nextSibling) {
        if (n.nodeType === 3 && n.textContent.trim()) { texte = true; break; }
      }
      var media = MEDIA.test(e.tagName);
      var carte = false;
      if (!texte && !media && r.width < W * .94 && r.height > 20) {
        var c = getComputedStyle(e);
        /* une CARTE se distingue de son sol : ombre, bordure, ou fond d'une autre
           couleur que le parent peint. Un conteneur crème sur le crème n'en est pas
           une (relevé à 1 440 : le conteneur des catégories bornait l'air). */
        if (c.boxShadow !== 'none' || parseFloat(c.borderTopWidth) > 0 || (c.backgroundImage !== 'none' && !/url\(/.test(c.backgroundImage))) carte = true;
        else if (c.backgroundColor !== 'rgba(0, 0, 0, 0)') {
          var moi = rgb(c.backgroundColor), lui = null;
          for (var q = e.parentElement; q && !lui; q = q.parentElement) lui = rgb(getComputedStyle(q).backgroundColor);
          carte = !!moi && (!lui || Math.max(Math.abs(moi[0] - lui[0]), Math.abs(moi[1] - lui[1]), Math.abs(moi[2] - lui[2])) > MEME_SOL);
        }
      }
      if (!(texte || media || carte)) continue;
      if (!visible(e) || fixe(e)) continue;
      var dy = decalage(e);
      if (r.top - dy < haut) haut = r.top - dy;
      if (r.bottom - dy > bas) bas = r.bottom - dy;
    }
    return { haut: haut + scrollY, bas: bas + scrollY };
  };

  /* le sol : la couleur du fond peint le plus profond qui contient le point */
  var rgb = function (txt) {
    var m = String(txt).match(/rgba?\(([\d.]+),\s*([\d.]+),\s*([\d.]+)(?:,\s*([\d.]+))?\)/);
    if (!m) return null;
    if (m[4] !== undefined && +m[4] < .5) return null;
    return [+m[1], +m[2], +m[3]];
  };
  /* LE SOL, lu à TROIS abscisses (bord gauche, milieu, bord droit) : à 1 440 px
     le bord gauche d'« À propos » est une PHOTO sombre, et le sol lu là valait le
     crème par défaut — la césure ne se posait pas entre deux bruns. On ignore ce
     qui est une image, on compte les fonds des pseudo-éléments posés à fond perdu,
     et on garde la couleur la plus fréquente. */
  var solEn = function (racines, x, yPage) {
    var trouve = null, profondeur = -1;
    racines.forEach(function (racine) {
      var candidats = [racine].concat(Array.prototype.slice.call(racine.querySelectorAll('*')));
      candidats.forEach(function (e) {
        if (e.classList && e.classList.contains(CLASSE)) return;
        if (MEDIA.test(e.tagName) || e.tagName === 'PICTURE') return;
        var r = e.getBoundingClientRect();
        var dy = decalage(e);
        if (x < r.left || x > r.right || yPage < r.top - dy + scrollY || yPage > r.bottom - dy + scrollY) return;
        var d = 0; for (var q = e; q; q = q.parentElement) d++;
        var c = getComputedStyle(e);
        var coul = rgb(c.backgroundColor) || (c.backgroundImage !== 'none' && !/url\(/.test(c.backgroundImage) ? rgb(c.backgroundImage) : null);
        if (coul && d >= profondeur) { profondeur = d; trouve = coul; }
        ['::before', '::after'].forEach(function (ps) {
          var t = getComputedStyle(e, ps);
          if (t.content === 'none' || t.position !== 'absolute') return;
          if (parseFloat(t.top) !== 0 || parseFloat(t.left) !== 0) return;
          var pc = rgb(t.backgroundColor) || (t.backgroundImage !== 'none' && !/url\(/.test(t.backgroundImage) ? rgb(t.backgroundImage) : null);
          if (pc && d + .5 >= profondeur) { profondeur = d + .5; trouve = pc; }
        });
      });
    });
    return trouve;
  };
  var solSous = function (racines, yPage) {
    var W = document.documentElement.clientWidth;
    var vus = [4, Math.round(W / 2), W - 5].map(function (x) { return solEn(racines, x, yPage); }).filter(Boolean);
    if (!vus.length) return rgb(getComputedStyle(document.body).backgroundColor) || [250, 247, 245];
    var meilleur = vus[0], score = 0;
    vus.forEach(function (c) {
      var n = vus.filter(function (o) { return Math.max(Math.abs(o[0] - c[0]), Math.abs(o[1] - c[1]), Math.abs(o[2] - c[2])) <= MEME_SOL; }).length;
      if (n > score) { score = n; meilleur = c; }
    });
    return meilleur;
  };

  var poser = function () {
    cache = new Map();
    Array.prototype.forEach.call(document.querySelectorAll('.' + CLASSE), function (l) { l.remove(); });
    var sections = Array.prototype.filter.call(document.querySelectorAll('.shopify-section'), function (s) {
      return visible(s) && !s.closest('.offcanvas') && !/announcement|__header/.test(s.id);
    });
    var blocs = sections.map(function (s) {
      var b = bornes(s); b.membres = [s]; return b;
    }).filter(function (b) { return isFinite(b.haut); }).sort(function (a, b) { return a.haut - b.haut; });
    for (var i = 0; i + 1 < blocs.length;) {
      if (blocs[i + 1].haut < blocs[i].bas - 1) {
        blocs[i].bas = Math.max(blocs[i].bas, blocs[i + 1].bas);
        blocs[i].membres = blocs[i].membres.concat(blocs[i + 1].membres);
        blocs.splice(i + 1, 1);
      } else i++;
    }
    var W = document.documentElement.clientWidth;
    var journal = [];
    if (window.vjCesures) window.vjCesures.journal = journal;
    for (var k = 0; k + 1 < blocs.length; k++) {
      var A = blocs[k], B = blocs[k + 1];
      if (B.haut - A.bas < 16) continue;
      /* le sol se lit DANS la section : quand le contenu va jusqu'au bord (« À
         propos » à 1 440), 2 px plus bas on est déjà hors de la section et l'on
         retombait sur le crème par défaut */
      var basA = Math.max.apply(null, A.membres.map(function (m) { var r = m.getBoundingClientRect(); return r.bottom - decalage(m) + scrollY; }));
      var hautB = Math.min.apply(null, B.membres.map(function (m) { var r = m.getBoundingClientRect(); return r.top - decalage(m) + scrollY; }));
      var solA = solSous(A.membres, Math.min(A.bas + 2, basA - 2));
      var solB = solSous(B.membres, Math.max(B.haut - 2, hautB + 2));
      var ecart = Math.max(Math.abs(solA[0] - solB[0]), Math.abs(solA[1] - solB[1]), Math.abs(solA[2] - solB[2]));
      journal.push({ a: A.membres.map(function (m) { return m.id.slice(-24); }).join('+'), b: B.membres.map(function (m) { return m.id.slice(-24); }).join('+'), bas: Math.round(A.bas), haut: Math.round(B.haut), solA: solA.join(','), solB: solB.join(','), pose: ecart <= MEME_SOL });
      if (ecart > MEME_SOL) continue;
      var milieu = Math.round((A.bas + B.haut) / 2);
      var hote = null;
      A.membres.concat(B.membres).forEach(function (s) {
        var r = s.getBoundingClientRect(), d = decalage(s);
        if (milieu >= r.top - d + scrollY && milieu < r.bottom - d + scrollY) hote = s;
      });
      if (!hote) hote = B.membres[0];
      if (getComputedStyle(hote).position === 'static') hote.style.position = 'relative';
      var rh = hote.getBoundingClientRect();
      var dyh = decalage(hote);
      var lum = .2126 * solA[0] + .7152 * solA[1] + .0722 * solA[2];
      var l = document.createElement('div');
      l.className = CLASSE + ' ' + CLASSE + (lum > 150 ? '--creme' : '--brun');
      l.setAttribute('aria-hidden', 'true');
      l.style.top = (milieu - Math.round(rh.top - dyh + scrollY)) + 'px';
      l.style.left = (-Math.round(rh.left)) + 'px';
      l.style.width = W + 'px';
      hote.appendChild(l);
    }
  };

  /* exposé pour l'épreuve et le diagnostic : `vjCesures.poser()`, `vjCesures.journal` */
  window.vjCesures = { poser: function () { poser(); return window.vjCesures.journal; }, journal: [] };

  var minute = null;
  /* VJ-CORR-D581 — 4 octobre 2026 — LA MESURE N'INTERROMPT PLUS UN DÉFILEMENT.
     Rachid : « il faut bien faire attention à ce que le site soit fluide à tous les
     niveaux et sur tous les devices ». Mesuré au DOIGT (tmp-r42-fluidite.js et
     tmp-r42-saccades.js, téléphone 402, processeur ×4) : sur l'accueil, 7 trames de plus
     de 50 ms pendant un défilement de 4 000 px, et cinq des tâches longues étaient CE
     script (83 à 101 ms chacune) — relancé 180 ms après chaque fin d'apparition, c'est-
     à-dire en plein geste. La césure ne change pas pour autant : `poser()` mesure la
     position de REPOS, et les traits du chargement sont déjà à leur place. On attend
     donc que la page soit immobile (300 ms sans défilement), puis un moment libre du
     navigateur (requestIdleCallback, 1 s au plus), et alors seulement on mesure. */
  var dernierDefilement = 0;
  window.addEventListener('scroll', function () { dernierDefilement = Date.now(); }, { passive: true });
  var mesurer = function () {
    /* on mesure à défilement nul d'en-tête : peu importe, tout est relatif à la
       section hôte, qui bouge avec le contenu */
    try { poser(); } catch (e) {}
  };
  var bientot = function () {
    clearTimeout(minute);
    minute = setTimeout(function attendre() {
      var calme = Date.now() - dernierDefilement;
      if (calme < 300) { minute = setTimeout(attendre, 320 - calme); return; }
      if (window.requestIdleCallback) window.requestIdleCallback(mesurer, { timeout: 1000 });
      else mesurer();
    }, 180);
  };

  var demarrer = function () {
    bientot();
    window.addEventListener('load', bientot);
    window.addEventListener('resize', bientot);
    window.addEventListener('vj:grille-remplacee', bientot);
    /* à la fin d'une apparition, les bornes sont définitives : on repose */
    document.addEventListener('transitionend', function (e) {
      if (e.target && e.target.classList && (e.target.classList.contains('vj-reveal') || e.target.classList.contains('aos-init')) && e.propertyName === 'transform') bientot();
    }, true);
    document.addEventListener('shopify:section:load', bientot);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(bientot);
    if (window.ResizeObserver) {
      var hauteur = 0;
      new ResizeObserver(function () {
        var h = Math.round(document.body.scrollHeight);
        if (Math.abs(h - hauteur) > 2) { hauteur = h; bientot(); }
      }).observe(document.body);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
